import React, { useEffect, useState } from "react";
import { ResponseInterface } from "../../../interfaces/ResponseInterface";
import { PaginationInterface, structPagination } from "../../../interfaces/PaginationInterface";
import QPagination from "../../../common/components/QPaging";
import QLoading from "../../../common/components/QLoading";
import { useHistory} from "react-router-dom";
import { RouteDefine } from "../../../routes/RouteDefine";
import { UseMainLayout } from "../../../context/LayoutContext";
import QSearch from "../../../common/components/Genneral/QSearch";
import { config } from "../../../config";
import QHeaderTable from "../../../common/components/Genneral/QHeaderTable";
import QSelectPerPage from "../../../common/components/Genneral/QSelectPerPage";
import UserApi from "../../../common/api/functions/User";
import { UserInterface } from "../../../interfaces/private/UserInterface";
import { UserConfig } from "./config";
import QIconSwitch from "../../../common/components/QIcon/QIconSwitch";
import {QHelpers} from "../../../common/helpers";
import {Button, FormGroup, Input, Label} from "reactstrap";
import { useDispatch } from "react-redux";
import { setToast } from "../../../app/rootReducer";
import QModal from "../../../common/components/QModal";
import BodyModalUserDetailComponent from "./components/BodyModalUserDetailComponent";

const DELETE_CONFIRM_TEXT = 'delete';




const SwitchButton = ({ user }: { user: UserInterface }) => {
    const [status, setStatus] = useState(user.status);


    async function toggleSwitch(id: any) {
        const newStatus = !status;
        setStatus(newStatus);
        try {
            let response: ResponseInterface | any = await UserApi.toggleStatus(id)
            if (response.status === config.STATUS_CODE.OK) {
                // setStatus(response.data.data.status)
            }
        } catch (err) {
            setStatus(!newStatus);
        }
    }
    return (
        <FormGroup switch>
            <Input
                type="switch"
                checked={status}
                onChange={() => toggleSwitch(user.id)}
            />
        </FormGroup>
    );
}

const Admin = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [userChecked, setUserChecked] = useState<any>({
        isCheckAll: false,
        arrUser: [],
    });
    const [deletingId, setDeletingId] = useState<string | number | null>(null);
    const [userToDelete, setUserToDelete] = useState<UserInterface | null>(null);
    const [deleteConfirmText, setDeleteConfirmText] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [userDetail, setUserDetail] = useState<UserInterface | null>(null);
    const [openDetailModal, setOpenDetailModal] = useState(false);

    const [users, setUsers] = useState<Array<UserInterface>>([]);
    const [pagination, setPagination] = useState<PaginationInterface | any>({
        ...structPagination,
        key: 'email',
        sort: 'desc',
    })
    const [loading, setLoading] = useState(true);

    UseMainLayout();

    useEffect(() => {
        if (loading) {
            loadUser().then(async () => {
                await setLoading(false);
            });
        }
    }, [loading])
    const loadUser = async () => {
        try {
            let response: ResponseInterface|any = await UserApi.getAll(pagination)
            if (response.status === config.STATUS_CODE.OK) {
                response = response.data.data;
                await setUsers(
                    response?.data || []
                )
                await setPagination({
                    ...pagination,
                    page: response.current_page,
                    total: response.total,
                    per_page: response.per_page
                })
            }else if(response.status === config.STATUS_CODE.FORBIDDEN){
                history.push(RouteDefine.forbidden)
            }

        } catch (err) {
        }
        if (loading) {
            await setLoading(false);
        }
    }

    const openUserDetail = (user: UserInterface) => {
        setUserDetail(user);
        setOpenDetailModal(true);
    }

    const closeUserDetail = () => {
        setOpenDetailModal(false);
        setUserDetail(null);
    }

    const openDeleteConfirm = (user: UserInterface) => {
        setUserToDelete(user);
        setDeleteConfirmText('');
        setOpenDeleteModal(true);
    }

    const closeDeleteConfirm = () => {
        setOpenDeleteModal(false);
        setUserToDelete(null);
        setDeleteConfirmText('');
    }

    const handleDeleteUser = async () => {
        if (!userToDelete || deleteConfirmText !== DELETE_CONFIRM_TEXT) {
            return;
        }

        setDeletingId(userToDelete.id);
        try {
            const response: ResponseInterface | any = await UserApi.deleteByAdmin(userToDelete.id);
            if (response.status === config.STATUS_CODE.OK) {
                dispatch(setToast({
                    message: 'User deleted successfully.',
                    type: config.TOAST_TYPE.SUCCESS,
                }));
                closeDeleteConfirm();
                setLoading(true);
            } else {
                dispatch(setToast({
                    message: response?.data?.message || 'Failed to delete user.',
                    type: config.TOAST_TYPE.ERROR,
                }));
            }
        } catch (err: any) {
            dispatch(setToast({
                message: err?.response?.data?.message || 'Failed to delete user.',
                type: config.TOAST_TYPE.ERROR,
            }));
        } finally {
            setDeletingId(null);
        }
    }



    const canConfirmDelete = deleteConfirmText === DELETE_CONFIRM_TEXT;

    return (
        <React.Fragment>
            <QModal
                open={openDetailModal}
                setOpen={(open: boolean) => {
                    if (!open) {
                        closeUserDetail();
                        return;
                    }
                    setOpenDetailModal(open);
                }}
                onClosed={closeUserDetail}
                headerContent={<span>User detail</span>}
                bodyContent={<BodyModalUserDetailComponent user={userDetail} />}
            />
            <QModal
                open={openDeleteModal}
                setOpen={(open: boolean) => {
                    if (!open) {
                        closeDeleteConfirm();
                        return;
                    }
                    setOpenDeleteModal(open);
                }}
                onClosed={closeDeleteConfirm}
                headerContent={<span>Delete user</span>}
                bodyContent={
                    <div>
                        <p className="mb-2">
                            You are about to permanently delete{' '}
                            <strong>{userToDelete?.email}</strong>.
                        </p>
                        <p className="text-muted mb-3">
                            This removes the account and related sync data. This cannot be undone.
                        </p>
                        <FormGroup>
                            <Label for="admin-delete-confirm">
                                Type <strong>{DELETE_CONFIRM_TEXT}</strong> to confirm
                            </Label>
                            <Input
                                id="admin-delete-confirm"
                                type="text"
                                value={deleteConfirmText}
                                autoComplete="off"
                                placeholder={DELETE_CONFIRM_TEXT}
                                onChange={(e) => setDeleteConfirmText(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && canConfirmDelete && !deletingId) {
                                        handleDeleteUser();
                                    }
                                }}
                            />
                        </FormGroup>
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                color="secondary"
                                outline
                                type="button"
                                className="me-2"
                                disabled={!!deletingId}
                                onClick={closeDeleteConfirm}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="danger"
                                type="button"
                                disabled={!canConfirmDelete || !!deletingId}
                                onClick={handleDeleteUser}
                            >
                                {deletingId ? 'Deleting...' : 'Delete user'}
                            </Button>
                        </div>
                    </div>
                }
            />
            <div className="col-md-12">
                <div className="row ">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <div className="page-title-name">Admin</div>
                            <div className="page-title-right">
                                <div className="d-flex">

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="mb-3">
                            <div className="card-header align-items-center d-flex">
                                <QSearch
                                    onChange={async (value: string) => {
                                        await setPagination({
                                            ...pagination,
                                            search: value,
                                        })
                                        await setLoading(true);
                                    }}
                                />
                                <QSelectPerPage pagination={pagination} setPagination={setPagination} setLoading={setLoading} />
                            </div>
                            <QLoading loading={loading} />
                            <table className="table align-middle table-nowrap mb-0" id="customerTable">
                                <QHeaderTable
                                    paging={pagination}
                                    setPaging={async (p: any) => {
                                        await setPagination(p);
                                        await setLoading(true);
                                    }}
                                    headers={UserConfig.headers}
                                    funcChecked={() => {

                                        let arrUser = [];
                                        if (!userChecked.isCheckAll) {
                                            arrUser = users?.map((u: UserInterface) => u.email);
                                        }

                                        setUserChecked({
                                            ...userChecked,
                                            isCheckAll: !userChecked.isCheckAll,
                                            arrUser: arrUser,
                                        })
                                    }}
                                />
                                <tbody className="list form-check-all">
                                    {users?.map((user: UserInterface, index: number) => {
                                        const isPrimaryAdmin = !!user.is_primary_admin;
                                        return (
                                            <tr key={user.id ?? index}>
                                                <td>{user.id}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-start"
                                                        onClick={() => openUserDetail(user)}
                                                        title="View detail"
                                                    >
                                                        {user.email}
                                                    </button>
                                                </td>
                                                <td>{user.company_name || '—'}</td>
                                                <td>{user.account_number || '—'}</td>
                                                <td>
                                                    <span className={`badge ${user.sync_engine_version === 'v2' ? 'bg-primary' : 'bg-secondary'}`}>
                                                        {(user.sync_engine_version || 'v1').toUpperCase()}
                                                    </span>
                                                </td>
                                                <td>{<SwitchButton user={user}/>}</td>
                                                <td>
                                                    {!isPrimaryAdmin ? (
                                                        <div
                                                            className={'d-flex justify-content-center cursor-pointer'}
                                                            title="Switch user"
                                                            onClick={async () => {
                                                                const response = await UserApi.switchUser(user.id);
                                                                if (response?.data?.data?.access_token) {
                                                                    QHelpers.store.setImpersonationToken(
                                                                        response.data.data.access_token
                                                                    )
                                                                    QHelpers.store.setImpersonationUser(
                                                                        response.data.data.user ?? {
                                                                            ...user,
                                                                            sync_engine_version: user.sync_engine_version || 'v1',
                                                                        }
                                                                    )
                                                                    await history.push(RouteDefine.dashboard);
                                                                }
                                                            }}
                                                        >
                                                            <QIconSwitch />
                                                        </div>
                                                    ) : (
                                                        <span className="text-muted">—</span>
                                                    )}
                                                </td>
                                                <td>
                                                    {!isPrimaryAdmin ? (
                                                        <div className="d-flex justify-content-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-danger"
                                                                disabled={deletingId === user.id}
                                                                onClick={() => openDeleteConfirm(user)}
                                                                title="Delete user"
                                                            >
                                                                <i className="fa fa-trash" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <span className="text-muted">—</span>
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <QPagination
                            pagination={pagination}
                            setPagination={setPagination}
                            setLoading={setLoading}
                        />
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}
export default React.memo(Admin);
